import { createContext } from 'react';
import { Tokens } from './tokens';

export interface NullableTokenContextData {
    tokens: Tokens | null;
    setAccessToken: (accessToken: string) => void;
    setTokens: (options: { accessToken: string; refreshToken: string }) => void;
    deleteTokens: () => void;
}

export const NullableTokensContext = createContext<
    NullableTokenContextData | undefined
>(undefined);

export interface TokensContextData {
    tokens: Tokens;
}

export const TokensContext = createContext<TokensContextData | undefined>(
    undefined
);
